module.exports = __webpack_public_path__ + "img/trevor_the_toad.7d5afd0f.jpg";